// @ts-nocheck
export const LIST_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const LIST_DEFAULT_PAGE_SIZE = LIST_PAGE_SIZE_OPTIONS[0];
